import { Camera } from 'lucide-react';

function ReceiptCaptureButton({ isLoading, onSelect }) {
  function handleFileChange(event) {
    const file = event.target.files?.[0];

    if (file) {
      onSelect(file);
    }

    event.target.value = '';
  }

  return (
    <label className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-full border border-[var(--theme-border)] bg-[var(--theme-accent-soft)] px-4 py-2 text-[0.82rem] font-semibold text-[var(--theme-text-subtle)] transition hover:border-[var(--theme-accent)] hover:bg-[var(--theme-accent-panel)] hover:text-[var(--theme-accent-panel-text)]">
      <Camera className="h-4 w-4" aria-hidden="true" />
      {isLoading ? 'Reading receipt...' : 'Upload Receipt'}
      <input
        className="sr-only"
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFileChange}
        disabled={isLoading}
      />
    </label>
  );
}

export default ReceiptCaptureButton;
